const STORAGE_KEY = 'SIGA_FAVORITES';
export const FAVORITES_CHANGED_EVENT = 'siga:favorites-changed';

export function loadFavorites() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveFavorites(routes) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(routes));
  window.dispatchEvent(new Event(FAVORITES_CHANGED_EVENT));
}
